<template lang="pug">
div.nse-poster-preview.style-poet
	poster-background(
		:spec="spec"
		:selected-items="selectedItems"
	)

	border-starmap-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
	)
		svg(xmlns='http://www.w3.org/2000/svg' width='699.958' height='604.646' viewBox='0 0 699.958 604.646')
			path#Path_291(data-name='Path 291'
				d='M79.256-317.641c-.467-.616-.148-1.327-.243-1.987v-3.2a53.056,53.056,0,0,0-.38-8.9,194.2,194.2,0,0,0-5.411-27.18,194.126,194.126,0,0,0-24.971-54.763A194.716,194.716,0,0,0,12.286-454.43a195.664,195.664,0,0,0-38.211-25.58,187.135,187.135,0,0,0-34.748-13.666c-13.848-3.88-27.881-6.72-42.356-6.691h-21.842a94.257,94.257,0,0,0-13.124.7,192.756,192.756,0,0,0-70.6,23.235,193.172,193.172,0,0,0-60.168,52.473c-1.784,2.369-1.783,2.365-3.563.016A193.95,193.95,0,0,0-311.79-463.01a191.342,191.342,0,0,0-62.773-30.831c-13.482-3.758-27.139-6.472-41.209-6.528,0,.054-23.4.156-24.5.154-8.214.474-16.4,1.182-24.549,2.379a213.247,213.247,0,0,0-45.826,11.809A168.426,168.426,0,0,0-565.018-452.7c-22.393,20.663-37.182,46.017-46,75a209.1,209.1,0,0,0-7.711,37.427,252.449,252.449,0,0,0-1.826,40.1,170.235,170.235,0,0,0,3.631,27.677,230.05,230.05,0,0,0,15.007,45.149,367.671,367.671,0,0,0,31.852,56.653c19.508,28.926,41.84,55.571,65.677,80.987,22.755,24.263,46.81,47.188,71.72,69.222q43.526,38.5,90.018,73.368c22.964,17.325,46.334,34.075,70.289,50.005.567.377,1.3.6,1.512,1.378h.471c.244-.75.963-.988,1.526-1.38,3.02-2.106,6.067-4.173,9.078-6.29q53.679-37.728,104.208-79.575c34.145-28.232,67.141-57.725,98.346-89.2C-37.676-91.89-18.92-112.3-1.363-133.818a524.551,524.551,0,0,0,43.976-61.769C55.255-216.67,66-238.629,72.831-262.343A151.651,151.651,0,0,0,78.875-294.1a4.988,4.988,0,0,0,.138-1.738v-1.037c.1-.65-.223-1.35.243-1.953Zm-5.238,19.854a165.826,165.826,0,0,1-8.162,42.073c-6.53,20.393-15.869,39.487-26.728,57.877a500.04,500.04,0,0,1-40.36,57.753A833.913,833.913,0,0,1-60.28-74.327q-23.5,23.746-48.362,46.061-39.68,35.739-81.783,68.6c-25.427,19.914-51.3,39.217-77.94,57.5a4.41,4.41,0,0,0-.575.408c-1.1,1.052-2.073.836-3.3.024q-15.08-10.017-29.85-20.483-61.857-43.761-119.2-93.283a1064.965,1064.965,0,0,1-83.885-80.647,648.09,648.09,0,0,1-55.545-68.087A383.972,383.972,0,0,1-593.549-219.8a239.266,239.266,0,0,1-17.238-48.08,166.229,166.229,0,0,1-4.539-39.337,268.08,268.08,0,0,1,3.288-40.713c3.828-23.653,11.26-46.035,23.636-66.649,15.4-25.651,36.578-45.152,63.1-58.9a195.551,195.551,0,0,1,55-18.456,240.919,240.919,0,0,1,53.37-3.892,186.878,186.878,0,0,1,83.256,23A190.93,190.93,0,0,1-272.266-419.7c.518.686,1.046,1.365,1.723,2.248,3.3-4.37,6.533-8.5,9.979-12.46a189.875,189.875,0,0,1,84.544-56.533A183.036,183.036,0,0,1-127-495.665c43.779-2.179,83.782,9.065,119.789,34.044A188.216,188.216,0,0,1,51.775-395.3a187.985,187.985,0,0,1,19.354,55.17,180.069,180.069,0,0,1,2.889,42.343Z'
				transform='translate(620.702 500.38)'
				:fill='colorTexture')


	star-map-preview(
		:spec="spec"
		:selected-items="selectedItems"
		:clip-path="clipPath"
		:dimensions="dimensions"
		:background-color="bgStarmap"
	)

	text-element-preview(
		v-if="spec.text_detail"
		:spec="spec.text_detail"
		:selected-items="selectedItems"
		:text-color-force="colorTexture"
		:font-family="selectedItems.detail_font"
	)
		div.text-content
			div(v-html="textTitle")
			div(v-html="textDateTime")
			div(v-html="textLocation")
			div(v-html="textCoordinate")

	text-element-preview(
		v-if="spec.text_saying"
		:spec="spec.text_saying"
		:selected-items="selectedItems"
		:text-color-force="colorTexture"
		:font-family="selectedItems.message_font"
	)
		div.text-content
			div(v-html="textSaying")


	border-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
		:border-color="colorTexture"
	)

	frame-physical-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
	)
</template>


<script>
import {computed} from "vue";
import ParseSpecifications from "@/commons/ParseSpecifications";
import TextElementPreview from "@/preview/components/TextElement";
import TextParse from "@/commons/TextParse";
import StarMapPreview from "@/preview/components/StarMapPreview";
import PathSvg from "@/commons/PathSvg";
import {PreviewHelper} from "@/preview/PreviewHelper";

export default {
	name: "PoetStyle",
	components: {StarMapPreview, TextElementPreview},
	props: {
		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		}
	},

	setup(props) {
		const spec = computed(() => {
			return ParseSpecifications.parse(props.selectedItems.poster_size, props.dimensions)
		});

		const { textColor } = PreviewHelper(props);
		const colorTexture = computed(() => {
			return `${textColor.value}`;
		});

		const {
			textSaying,
			textLocation,
			textCountry,
			textCity,
			textCoordinate,
            textDateTime,
			textTitle
		} = TextParse(props);

		const clipPath = PathSvg.heart(window.nse_app.star_map_width_mobile)

		const styleBG = computed(() => {
			return `background-color: ${bgStarmap.value}`
		})

		const bgStarmap = computed(() => {
			return props.selectedItems.background_color ? props.selectedItems.background_color.value : ''
		});

		return {
			bgStarmap,
			spec,
			colorTexture,
			textSaying,
			textLocation,
            textDateTime,
			textCountry,
			textCity,
			textCoordinate,
			textTitle,
			clipPath,
			styleBG,
		}
	}
}
</script>


